jQuery(function($){
  var swiper = new Swiper('.works-slider__slider', {
    slidesPerView: 1.2,
    spaceBetween: 14,
    freeMode: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 2.2,
        scrollbar: false
      }
    },
    navigation: {
      prevEl: '.works-slider__prev',
      nextEl: '.works-slider__next'
    }
  });
});
